import dropdownStyle from '../../../../shared/styles/semantic-ui-dropdown.styled';
import tw, { styled } from 'twin.macro';

export const DateTimeWrapper = styled.div`
  ${tw`flex w-full`}
  & img {
    ${tw`absolute pl-4 pt-4`}
  }
  & input {
    ${tw`bg-transparent pl-10`}
  }
`;
export const DateWrapper = styled.div`
  ${tw`w-full`}
  div.flatpickr {
    ${tw`w-full mx-0 px-0 outline-none flex items-center text-base bg-white border border-solid border-fieldGray rounded opacity-70`};
    position: relative;

    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      border-color: var(--formFieldBorderColor, #DADADA);
      background: var(--formFieldBackgroundColor);
      border-radius: var(--formFieldBorderRadius);
    `}

    .grey {
      margin-top: -9px;
    }

    &:focus {
      border-color: #85b7d9;
    }
  }

  & .flatpickr-input,
  & .date-picker.form-control.input {
    ${tw`w-full mx-0 py-3.5 pl-6 pr-1 outline-none text-base border-none`};
    font-family: 'Inter' !important;
    flex: 1;
    ${({ notInBuilder }) =>
      notInBuilder &&
      `
      font-family: var(--formFontType) !important;
      color: var(--formFieldColor, var(--formTextColor));
    `}
  }

  & .input-button {
    border: 1px solid red;
    .icon-calendar {
      color: red !important;
    }
  }
`;
export const TimeWrapper = styled.div``;

export const DateFormatWrapper = styled.div`
  ${tw`flex mt-2`}
  gap: 10px;

  @media (min-width: 767px) {
    width: 70%;
  }

  & .ui.dropdown {
    ${dropdownStyle};
    outline: none !important;
    border: none !important;
    background: transparent !important;
    padding-left: 25px !important;
    border-radius: 0 !important;
    border-bottom: 1px solid #ccc !important;
  }

  & .format-type {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    > img {
      position: absolute;
      left: 0;
      height: 15px;
    }
  }
`;

export const CheckboxWrapper = styled.div`
  ${tw`font-medium`}
  & .time-checkbox {
    margin-top: 0.8rem;
  }
`;

export const updateCalendarUI = (instance, formDesign, disableYearEffect) => {
  const child = document.createElement('div');
  child.className = 'button-container';

  child.style.cssText = `
    color: black;
    width: 100%;
    height: 2rem;
    display: flex;
    flex-direction: row;
    background-color: white;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  `;

  const buttonStyles = `
    color: white;
    display: flex;
    flex: 0 0 50%;
    cursor: pointer;
    align-items: center;
    justify-content: center;
  `;

  const doneButtonStyles = `
    ${buttonStyles};
    background: linear-gradient(270deg, #00afbf, #1a8caf);
  `;

  const clearButtonStyles = `
    ${buttonStyles};
    background-color: #555;
  `;

  const doneButton = document.createElement('div');
  doneButton.innerText = 'Done';
  doneButton.onclick = () => instance.close();
  doneButton.style.cssText = doneButtonStyles;

  const clearButton = document.createElement('div');
  clearButton.innerText = 'Clear';
  clearButton.onclick = () => {
    instance.clear();
    instance.close();
  };
  clearButton.style.cssText = clearButtonStyles;

  child.append(clearButton, doneButton);
  if (instance?.calendarContainer) {
    if (disableYearEffect) {
      instance.calendarContainer.querySelector('.numInputWrapper').style.display = 'none';
      instance.calendarContainer.querySelector('.flatpickr-weekdays').style.display = 'none'; 
    }

    const weekDays = instance.calendarContainer.querySelectorAll('.flatpickr-weekday');
    weekDays.forEach((weekDay) => {
      weekDay.style.fontFamily = formDesign?.old.form_font || 'Quicksand';
    });

    instance.calendarContainer.appendChild(child);
    instance.calendarContainer.style.fontFamily = formDesign?.old.form_font || 'Quicksand';
  }
};
